export const CARDS_BLOCK_b03 =   {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#180024",
    "padding": "120px 20px 120px 20px"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#ffffff",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company",
      "styleProps": {
        "color": "#ffffff99",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardElements": [
    {
      "type": "text",
      "id": 1746533060416,
      "elIndex": 0,
      "text": "[[id]]",
      "location": "A",
      "params": [
        {
          "value": "id",
          "label": "id"
        }
      ],
      "styleProps": {
        "padding": "0px 0px 20px 0px",
        "text-align": "left",
        "color": "#ffffff44",
        "font-size": "8rem",
        "line-height": "1",
        "font-weight": "500",
        "font-family-bk": "'Heebo', sans-serif",
        "font-family": "'Heebo', sans-serif"
      },
      "stylePropsTab": {
        "font-size": "4.5rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "3.75rem",
        "line-height": "1"
      }
    },
    {
      "type": "text",
      "id": 1746529638292,
      "elIndex": 1,
      "text": "[[name]]",
      "location": "B",
      "params": [
        {
          "value": "name",
          "label": "name"
        }
      ],
      "styleProps": {
        "color": "#ffffff",
        "font-size": "3rem",
        "line-height": "1",
        "font-weight": "300",
        "font-family-bk": "'Yanone Kaffeesatz', sans-serif",
        "font-family": "'Yanone Kaffeesatz', sans-serif",
        "font-family-cust": "",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsTab": {
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      },
      "fonts": {
        "styleProps": ""
      }
    }
  ],
  "cardConfig": {
    "perRow": {
      "mobile": 1,
      "tab": 1,
      "desktop": 3
    },
    "layout": "l5",
    "cardstyleProps": {
      "padding": "80px 10px 24px 10px"
    },
    "cardstylePropsTab": {
      "padding": "60px 10px 14px 10px"
    },
    "cardstylePropsMob": {
      "padding": "40px 0px 12px 0px"
    }
  },
  "configs": {
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1746629048690
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066"
  },
  "metaDataId": 1746629022464,
  "afterIndex": 0,
  "blockId": 1746629022464,
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  },
  "cardLocations": [
    {
      "name": "outer",
      "styleProps": {
        "background-image": "url('[[img]]')",
        "border-radius": "1rem",
        "padding": "0px 0px 0px 0px",
        "background-repeat": "no-repeat",
        "background-size": "cover",
        "background-color": "#ffffff",
        "background-position": "center"
      }
    },
    {
      "name": 0
    },
    {
      "name": "A",
      "styleProps": {
        "background-color": "",
        "margin": "0px 0px 0px 0px",
        "border-radius": "0px",
        "padding": "0px 0px 0px 0px",
        "box-shadow": "",
        "alignItems": "",
        "justify-content": "",
        "flex-direction": "",
        "display": "",
        "width": "100%",
        "text-align": "left",
        "background-image": "url('')",
        "background-repeat": "no-repeat",
        "background-position": "center",
        "background-size": "cover"
      },
      "stylePropsTab": {
        "padding": "0px 0px 0px 0px"
      },
      "stylePropsMob": {
        "padding": "0px 0px 0px 0px"
      },
      "innerDiv": {
        "styleProps": {
          "height": "384px",
          "display": "flex",
          "justify-content": "left",
          "background-image": "linear-gradient(to bottom,#00000088,#00000022)",
          "padding": "20px 20px 20px 20px",
          "border-radius": "0px",
          "background-color": "",
          "alignItems": "flex-start"
        },
        "stylePropsTab": {
          "height": "320px"
        },
        "stylePropsMob": {
          "height": "256px"
        }
      }
    },
    {
      "name": "B",
      "styleProps": {
        "padding": "0px 0px 0px 0px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": "center",
        "width": "100%",
        "alignItems": "",
        "text-align": "center",
        "background-image": "linear-gradient(to right,,)"
      },
      "innerDiv": {
        "styleProps": {
          "justify-content": "flex-end",
          "alignItems": "flex-start",
          "height": "256px",
          "background-image": "linear-gradient(to bottom,,)",
          "background-color": "#00000022",
          "padding": "20px 20px 20px 20px"
        },
        "stylePropsTab": {
          "height": "256px",
          "padding": "12px 12px 12px 12px"
        },
        "stylePropsMob": {
          "height": "256px",
          "padding": "11px 11px 11px 11px"
        }
      }
    },
    {
      "name": "C",
      "styleProps": {
        "width": "100%",
        "display": "flex",
        "flex-direction": "row",
        "alignItems": "center",
        "justify-content": "center",
        "text-align": "center"
      },
      "innerDiv": {
        "styleProps": {
          "width": "100%",
          "display": "flex",
          "flex-direction": "row",
          "alignItems": "center",
          "justify-content": "center"
        }
      }
    }
  ],
  "overlay": {
    "styleProps": {
      "background-color": ""
    }
  },
  "containerStyleProps": {
    "max-width": "1280px"
  }
}